@for(typeMission of this.typesMissions; track typeMission.code){
    <marv-tag         
        [color]="this.missionTypeService.getColor(typeMission.code)" 
        [size]="this.sizeLegend"
        [isClickable]="this.isClickable"
        [disabled]="typeMission.disabled"
        (onClickTag)="this.onClickTag($event, typeMission)"
        >{{typeMission.name | translate}}</marv-tag>
}